export default __webpack_public_path__ + "static/media/IMG_6894.b16418c7.jpg";